import { Endpoints, Project, ProjectUtils, TFile } from '@brg/api'
import { CreateLinkTo } from 'shared/constants/linkTo'
import { ImageRequest } from 'shared/constants/imageRequest'
import { getProjectImages } from 'shared/pages/project/sections/ps-image'
import { isOrganizationsEntityType } from 'shared/pages/teams/helpers/prepareCustomSortingGridFilter'
import { isTeamTabProjectWideCover } from './teamTabProjectCoverLayout'

const toCoverUrl = (value?: string) => {
  if (!value) return undefined
  if (value.startsWith('http') || value.startsWith('//') || value.startsWith('data:')) {
    return value
  }
  if (value.startsWith('/')) {
    return `${Endpoints.files}${value}`
  }
  return `${Endpoints.files}/${value}`
}

export const getProjectTitleFirstLetter = (project: Project): string => {
  const title = typeof project?.title === 'string' ? project.title.trim() : ''
  return (title.charAt(0) || '?').toUpperCase()
}

type OrderCardItem = Project & {
  contextName?: string
  route?: string
  teamId?: string
}

export const getTeamTabOrderCardUrl = (item: Project, entityType?: string): string | undefined => {
  if (!isOrganizationsEntityType(entityType)) {
    const projectUrl = CreateLinkTo.projectNew(item)
    return projectUrl || undefined
  }

  const team = item as OrderCardItem

  if (typeof team.route === 'string' && team.route.startsWith('http')) {
    return team.route
  }

  const slug = team.contextName || team.projectId || team.teamId
  if (!slug) {
    return undefined
  }

  return CreateLinkTo.team(slug)
}

const getLmsTitleImageFiles = (project: Project): TFile[] => {
  const team = project as OrderCardItem & {
    additionalInfo?: { lmstitleimage?: string }
    additionalContent?: { additionalInfo?: { lmstitleimage?: string } }
  }
  const raw = team?.additionalInfo?.lmstitleimage
    ?? team?.additionalContent?.additionalInfo?.lmstitleimage
    ?? '[]'

  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed) && parsed[0]?.files?.length) {
      return parsed[0].files as TFile[]
    }
  } catch {
    return []
  }

  return []
}

const getFileCoverUrl = (files?: TFile[]): string | undefined => {
  if (!files?.length) {
    return undefined
  }

  const file = files.find(({ size }) => size === 'original') || files[0]
  return file?.url ? toCoverUrl(file.url) : undefined
}

export const getTeamTabProjectCoverUrl = (project: Project, language = 'ru'): string | undefined => {
  const imageSize = isTeamTabProjectWideCover(project) ? ImageRequest.image : ImageRequest.tile
  const lmsTitleImageUrl = getFileCoverUrl(getLmsTitleImageFiles(project))
  if (lmsTitleImageUrl) {
    return lmsTitleImageUrl
  }

  const titleImageUrl = getFileCoverUrl(getProjectImages(project, language))
  if (titleImageUrl) {
    return titleImageUrl
  }

  const image = ProjectUtils.getTitleImageOrUndefined(project, imageSize)
  if (!image) {
    return undefined
  }

  return toCoverUrl(image)
}
import { Endpoints, Project, ProjectUtils, TFile } from '@brg/api'
import { CreateLinkTo } from 'shared/constants/linkTo'
import { ImageRequest } from 'shared/constants/imageRequest'
import { getProjectImages } from 'shared/pages/project/sections/ps-image'
import { isOrganizationsEntityType } from 'shared/pages/teams/helpers/prepareCustomSortingGridFilter'
import { isTeamTabProjectWideCover } from './teamTabProjectCoverLayout'

const toCoverUrl = (value?: string) => {
  if (!value) return undefined
  if (value.startsWith('http') || value.startsWith('//') || value.startsWith('data:')) {
    return value
  }
  if (value.startsWith('/')) {
    return `${Endpoints.files}${value}`
  }
  return `${Endpoints.files}/${value}`
}

export const getProjectTitleFirstLetter = (project: Project): string => {
  const title = typeof project?.title === 'string' ? project.title.trim() : ''
  return (title.charAt(0) || '?').toUpperCase()
}

type OrderCardItem = Project & {
  contextName?: string
  route?: string
  teamId?: string
}

export const getTeamTabOrderCardUrl = (item: Project, entityType?: string): string | undefined => {
  if (!isOrganizationsEntityType(entityType)) {
    const projectUrl = CreateLinkTo.projectNew(item)
    return projectUrl || undefined
  }

  const team = item as OrderCardItem

  if (typeof team.route === 'string' && team.route.startsWith('http')) {
    return team.route
  }

  const slug = team.contextName || team.projectId || team.teamId
  if (!slug) {
    return undefined
  }

  return CreateLinkTo.team(slug)
}

const getLmsTitleImageFiles = (project: Project): TFile[] => {
  const team = project as OrderCardItem & {
    additionalInfo?: { lmstitleimage?: string }
    additionalContent?: { additionalInfo?: { lmstitleimage?: string } }
  }
  const raw = team?.additionalInfo?.lmstitleimage
    ?? team?.additionalContent?.additionalInfo?.lmstitleimage
    ?? '[]'

  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed) && parsed[0]?.files?.length) {
      return parsed[0].files as TFile[]
    }
  } catch {
    return []
  }

  return []
}

const getFileCoverUrl = (files?: TFile[]): string | undefined => {
  if (!files?.length) {
    return undefined
  }

  const file = files.find(({ size }) => size === 'original') || files[0]
  return file?.url ? toCoverUrl(file.url) : undefined
}

export const getTeamTabProjectCoverUrl = (project: Project, language = 'ru'): string | undefined => {
  const imageSize = isTeamTabProjectWideCover(project) ? ImageRequest.image : ImageRequest.tile
  const lmsTitleImageUrl = getFileCoverUrl(getLmsTitleImageFiles(project))
  if (lmsTitleImageUrl) {
    return lmsTitleImageUrl
  }

  const titleImageUrl = getFileCoverUrl(getProjectImages(project, language))
  if (titleImageUrl) {
    return titleImageUrl
  }

  const image = ProjectUtils.getTitleImageOrUndefined(project, imageSize)
  if (!image) {
    return undefined
  }

  return toCoverUrl(image)
}
